import { render } from "./PendingReason.vue?vue&type=template&id=715c8a54&ts=true"
import script from "./PendingReason.ts?vue&type=script&lang=ts&external"
export * from "./PendingReason.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__